import axios from 'axios'

export default {
  methods: {
    drawHeatmap (url) {
      var self = this
      var map = self.$refs.mainMap.$mapObject
      var heatmapArray = [0, 2, 3]

      if (self.heatmap) {
        self.heatmap.setMap(null)
      }

      if (heatmapArray.includes(self.campaign.status)) {
        self.heatmap = new window.google.maps.visualization.HeatmapLayer({
          map: map,
          gradient: [
            'rgba(239, 125, 0, 0)',
            'rgba(239, 125, 0, 0)',
            'rgba(239, 125, 0, 0)',
            'rgba(239, 125, 0, 0)',
            'rgba(239, 125, 0, 0.1)',
            'rgba(239, 125, 0, 0.2)',
            'rgba(239, 125, 0, 0.3)',
            'rgba(239, 125, 0, 0.4)',
            'rgba(239, 125, 0, 0.5)',
            'rgba(239, 125, 0, 0.6)',
            'rgba(239, 125, 0, 0.7)',
            'rgba(239, 125, 0, 0.8)',
            'rgba(239, 125, 0, 0.9)',
            // 'rgba(239, 125, 0, 1)',
            // 'rgba(239, 125, 0, 1)',
            // 'rgba(239, 125, 0, 1)',
            // 'rgba(239, 125, 0, 1)',
            'rgba(239, 125, 0, 1)',
            '#f55f00',
            '#f17600',
            '#f36a00',
            '#f85400',
            '#fa4900',
            '#fd3e00',
            '#ff3300'
            // 'rgba(255,255,255,0)',
            // 'rgba(255,255,255,0)',
            // 'rgba(255,255,255,0)',
            // 'rgba(255,255,255,0)',
            // 'rgba(255,255,255,0)',
            // 'rgba(239, 125, 0, 1)',
            // 'rgba(239, 125, 0, 1)',
            // 'rgba(239, 125, 0, 1)',
            // 'rgba(239, 125, 0, 1)',
            // 'rgba(239, 125, 0, 1)',
            // 'rgba(239, 125, 0, 1)',
            // 'rgba(239, 125, 0, 1)',
            // 'rgba(239, 125, 0, 1)',
            // 'rgba(239, 125, 0, 1)',
            // 'rgba(239, 125, 0, 1)',
            // 'rgba(239, 125, 0, 1)',
            // 'red'
          ],
          radius: 100
        })
        self.loadHeatmapData(url)
      } else {
        self.$emit('heatmap')
      }
    },

    loadHeatmapData (url) {
      var self = this
      if (url.length) {
        axios({
          method: 'get',
          url,
          headers: {
            'Accept': 'application/json'
          }
        }).catch(
            () => alert('Journey data error')
        ).then(
            (r) => {
              var items = []
              for (var i = 0; i < r.data.features.length; i++) {
                let location = new window.google.maps.LatLng(r.data.features[i].geometry.coordinates[1], r.data.features[i].geometry.coordinates[0])

                let weight = r.data.features[i].properties.weight < 3000 ? r.data.features[i].properties.weight : 3000
                items.push({location, weight})
              }
              self.heatmap.setData(items)
              self.$emit('heatmap')
            }
        )
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/drawHeatmap.js